import { Outlet, useLocation } from "react-router-dom";
import LandingNav from "./LandingNav.js";
import "../styles/Landing.css"

export default function HomeLayout() {
  const location = useLocation();
  const usePlainBackground = location.pathname === "/how-it-works";

  return (
    <div className={`home-page${usePlainBackground ? " home-pagePlain" : ""}`}>
      <div className="landingCard">
        <LandingNav />
        <div className="homecontent">
          <Outlet />
        </div>
      </div>
    </div>
  );
}